import { render, staticRenderFns } from "./absent.vue?vue&type=template&id=2432d318&scoped=true&"
import script from "./absent.vue?vue&type=script&lang=js&"
export * from "./absent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2432d318",
  null
  
)

export default component.exports